import React from "react";
import {
  Typography,
  Chip,
  ButtonDS,
  Price,
} from "get-life-storybook-ts";
import { ChipI } from "get-life-storybook-ts/lib/atoms/Chip/Chip";

interface PriceData {
  price: string;
  priceLabel: string;
  decimals: string;
  frequency?: string;
  after?: string;
  PromoOnClick?: () => void;
}

interface PriceSummaryCardProps {
  titlePrice?: string;
  price: PriceData;
  tags: ChipI[];
  buttonText: string;
  onClick: () => void;
  priceChange?: boolean;
  subtitle?: string;
  tooltipText?: React.ReactNode;
  trustpilot?: string;
  showTrustpilot?: boolean;
}

const PriceSummaryCard: React.FC<PriceSummaryCardProps> = ({
  titlePrice,
  price,
  tags,
  buttonText,
  onClick,
  priceChange = false,
  subtitle,
  tooltipText,
  trustpilot,
  showTrustpilot,
}) => {
  return (
    <div className="flex flex-col justify-start items-center bg-white w-full py-[25px] md:py-[30px] md:min-h-[400px] gap-y-[24px]">
      {titlePrice && (
        <Typography
          variant="H3"
          weight="700"
          text={titlePrice}
          color="gray-text"
          className="text-[#424242] text-[22px] md:py-[33px]"
        />
      )}

      <Price
        loading={priceChange}
        {...price}
      />

      <div className="flex flex-row gap-[10px] items-center justify-center px-[24px] flex-wrap">
        {tags.map((tag, idx) => (
          <Chip
            key={`${tag.text}_${idx}`}
            text={tag.text}
            type="success"
            icon="CheckedIcon"
          />
        ))}
      </div>

      {subtitle && (
        <Typography variant="BodySmall" weight="400" text={subtitle} />
      )}

      {tooltipText && (
        <div className="text-center text-sm text-gray-500">
          {tooltipText}
        </div>
      )}

      <div className="w-full max-w-[325px]">
        <ButtonDS
          label={buttonText}
          onClick={onClick}
          rightIcon="ArrowRightIcon"
          className="w-full"
        />
      </div>

      {showTrustpilot && trustpilot && (
        <div className="flex flex-col items-center">
          <span
            className="BodyS font-normal text-[#686868]"
            dangerouslySetInnerHTML={{ __html: trustpilot }}
          />
        </div>
      )}
    </div>
  );
};

export default PriceSummaryCard;
